export default __webpack_public_path__ + "static/media/user-08.98c05135.jpg";